module.exports = __webpack_public_path__ + "fonts/YogaOT.d398039fe2d6f55d5e6e3f699c808dc7.woff";